import React from 'react';
import styled from 'styled-components';
import { Icons, ImpAccordion, ImpButton, ImpContainer, ImpFlex, ImpIcon, ImpList, ImpPad, ImpText, colors, } from '../..';
const IconContainer = styled(ImpContainer) `
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
const TextContainer = styled(ImpContainer) `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;
export function DisplayNumber({ title, subtitle, showIcon = true, onIconClick, index, }) {
    return (React.createElement(ImpContainer, { width: "100%", borderRadius: "12px", backgroundColor: colors.surface.surfaceHigh },
        React.createElement(ImpPad, { padding: "16px", fluid: true },
            React.createElement(ImpFlex, { direction: "column", align: "flex-start", justify: "center", fluid: true },
                React.createElement(ImpText, { typography: "headline1", mobileTypography: "headline3" }, title),
                React.createElement(TextContainer, null,
                    React.createElement(ImpText, { typography: "body1", color: colors.content.onBackgroundVariant, handleSuperscript: true }, subtitle),
                    showIcon && React.createElement(IconContainer, null,
                        React.createElement(ImpIcon, { iconSrc: Icons.question, onClick: onIconClick, stroke: colors.content.onSurfaceVariant, size: "16px", dataTestId: `question-icon-${index}`, ariaLabel: "More info" })))))));
}
export const PrimaryAction = ({ text, onClick, pageState, }) => (React.createElement(ImpButton, { buttonStyle: "branded", size: "fill", dataTestId: "primary-action", onClick: onClick, state: pageState === 'submitting' ? 'submitting' : 'enabled' }, text));
export const SecondaryAction = ({ text, onClick, pageState, }) => (React.createElement(ImpButton, { variant: "text", buttonStyle: "branded", dataTestId: "secondary-action", onClick: onClick, state: pageState === 'enabled' ? 'enabled' : 'disabled' }, text));
export function FeesSection({ info }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(ImpList, { ...info.feesList, useSurface: true }),
        info.feesDisclosure));
}
export function RewardsSection({ info }) {
    return (React.createElement(ImpContainer, { width: "100%" },
        React.createElement(ImpAccordion, { ...info.rewardsList })));
}
//# sourceMappingURL=ImpOfferPageComponents.js.map